import { debugInfo, debugInfoProd } from './debug';
import { HtmlId } from '../enums/elementId';

/**
 * Can be used to mount patterns with debugInfo integrated
 */
export const mountComponent = <Pattern, Props>(
    wrapperId: HtmlId,
    create: (containerElement: HTMLElement, props: Props) => Pattern,
    props: Props
): Pattern | undefined => {
    const containerEl = document.getElementById(wrapperId);

    if (!containerEl) {
        debugInfo('Couldn\'t mount element with id: ', wrapperId);

        return undefined;
    }

    try {
        return create(containerEl, props);
    } catch (error) {
        debugInfoProd(`Error while mounting brix pattern (id: ${wrapperId}): `, error);
        return undefined;
    }
};
